import React from 'react'
import usePortManager from '../hooks/use-port-manager'
import { observer } from 'mobx-react'

function ImageLayer ({src = null, name = null, className}) {

  const portManager = usePortManager()

  if (src === null && typeof portManager.getValue(name) === 'undefined'){
    return null
  }

  const size = portManager.getPortImageSize()
  const base_url = window.main_theme_objects.assets_url
  const relativeURL = src !== null ? src : portManager.getPortImageSrc(name)
  const fullSrc = base_url + relativeURL

  return (
    <img src={fullSrc} data-name={name} className={className + ' ' + size}/>
  )
}

export default observer(ImageLayer)